import React from 'react'

// DataPicker
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from "date-fns/locale/it";
// import pt from "date-fns/locale/pt-BR";

// Moment
import moment from "moment";
import "moment/locale/it";

// CSS
import './Date.css'

interface Props {
  date?: Date;
  availability: any;
  setDay: (day: Date) => void;
  disabled?: boolean;
}
const Date: React.FC<Props> = ({ date, availability, setDay, disabled }) => {

  let langSelected = "it";
  // @ts-ignore
  // if (langSelected === "pt") registerLocale("pt", pt);
  if (langSelected === "it") registerLocale("it", it);
  setDefaultLocale(langSelected);

  moment.locale("it");

  const specialMessage = {
    enabled: process.env.REACT_APP_DATE_MESSAGE_ON === "true",
    message: process.env.REACT_APP_DATE_MESSAGE,
    color: process.env.REACT_APP_DATE_MESSAGE_COLOR,
  }

  const isAllowedDate = (date: Date): boolean => {
    const dateToString = moment(date).format("YYYY-MM-DD");
    if (!availability) return false;
    if (availability.close && availability.close.includes(dateToString)) return false;
    // if (availability.full && availability.full.includes(dateToString)) return false; // to allow to select full date
    return true;
  };

  const isFullDate = (date: Date): string | null => {
    const dateToString = moment(date).format("YYYY-MM-DD");
    if (!availability) return null;
    if (availability.full && availability.full.includes(dateToString)) return "full";
    return null;
  };

  return (
    <>
      <div className="wrapper">

        <DatePicker
          disabledKeyboardNavigation
          name="datedate"
          selected={date}
          minDate={moment().add(0, "day").toDate()}
          maxDate={moment().add(3, "months").toDate()}
          filterDate={isAllowedDate}
          locale={langSelected}
          placeholderText={"Seleziona una data"}
          showIcon={true}
          value={date ? date.toLocaleDateString("it") : ""}
          dayClassName={isFullDate}
          inline={true}
          onChange={(date: Date) => setDay(date)}
          disabled={disabled}
          // todayButton={'Oggi'}
          // withPortal={false} // with inline prevent form imput to work
          className={'date-picker'}
        >
          {/* {specialMessage.enabled && (
            <div className="special-message" style={{ color: specialMessage.color }}>
              {specialMessage.message}
            </div>
          )} */}

        </DatePicker>
      </div>
      <div className="legend">
        <div className="label">Legenda</div>
        <div className="available">
          <span className="date">1</span>
          <span>Disponibile</span>
        </div>
        <div className="close">
          <span className="date">1</span>
          <span>Non disponibile</span>
        </div>
        <div className="full">
          <span className="date">1</span>
          <span>Lista d'attesa</span>
        </div>
        <div className="selected">
          <span className="date">{moment(date).format('D') ?? 1}</span>
          <span>Giorno scelto</span>
        </div>
      </div>
    </>
  )
}
export default Date;